import React, {Component} from 'react';
import {Route, Redirect} from 'react-router-dom';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import ProfiloUtenteEdit from './ProfiloUtenteForm';

class ProfiloUtenteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div>
      <Route exact path='/app/profiloutente' render={() => (
          <Redirect
              to='/app/profiloutente/edit'
          />
      )} />
      <MatchWhenLoggedIn path='/app/profiloutente/edit/:id' component={ProfiloUtenteEdit} />
    </div>)
  }
}

export default ProfiloUtenteContent;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/ProfiloUtenteContent.js
 **/